import config from '../config';

const API_URL = config.API_URL;

class ProductsService {
  /**
   * Récupérer tous les produits
   */
  async getAllProducts() {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_URL}/api/products`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Erreur lors de la récupération des produits');
    }

    return await response.json();
  }

  /**
   * Récupérer un produit spécifique
   */
  async getProduct(productId) {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_URL}/api/products/${productId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Erreur lors de la récupération du produit');
    }

    return await response.json();
  }

  /**
   * Créer un nouveau produit
   */
  async createProduct(productData) {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_URL}/api/admin/products`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(productData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Erreur lors de la création du produit');
    }

    return await response.json();
  }

  /**
   * Mettre à jour un produit
   */
  async updateProduct(productId, productData) {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_URL}/api/admin/products/${productId}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(productData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Erreur lors de la mise à jour du produit');
    }

    return await response.json();
  }

  /**
   * Supprimer un produit
   */
  async deleteProduct(productId) {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_URL}/api/admin/products/${productId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Erreur lors de la suppression du produit');
    }

    return await response.json();
  }

  /**
   * Rechercher des produits
   */
  async searchProducts(query) {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_URL}/api/products/search?q=${encodeURIComponent(query)}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Erreur lors de la recherche des produits');
    }

    return await response.json();
  }
}

export default new ProductsService();


